<template>

    <div class="row child-component">
        <div class="col-lg-7 col-md-8 col-sm-8 col-xs-6 mx-auto">
            <div class="d-block row col-lg-8 mx-auto">
                <div class="fieldborder">
                    <label>Employee Phone Number </label>
                    <the-mask type="text" @focus="ResetDirty('EmployeePhoneNumber')"
                        @blur="SetDirty('EmployeePhoneNumber')" :tokens="{ '#': { pattern: /\d/ } }"
                        :mask="['##', FormatPhoneNumber]" style="margin-top:1px;" class="form-control" autocomplete="off"
                        :maxlength="24" v-model="ProdEXPAmend.EmployeePhoneNumber" placeholder="Employee Phone Number"></the-mask>
                </div>
                <div class="fieldborder">
                    <label>ENTITY </label>
                    <OmniSelect class="" placeholder="Select Entity" name="Entity"
                    :showLabel="false" label="value" v-model="ProdEXPAmend.Entity" :options="EntityList"></OmniSelect>
                </div>
                <div class="fieldborder">
                    <label>AGENCY </label>
                    <OmniSelect placeholder="Select Agency" name="Media" :showLabel="false" label="Select Media"
                        :options="AgencyList" v-model="ProdEXPAmend.EmployeeAgency" />
                </div>
                <div class="fieldborder" style="margin-top: 0px;">
                    <b-form-group label="" class="timeonly-text">
                        <label>REQUEST TYPE </label>
                        <b-form-radio-group style="margin-left:10px;" class="omniipclass" id="time-only"
                            v-model="ProdEXPAmend.RequestType" name="time-only">
                            <b-form-radio value="production">PRODUCTION</b-form-radio>
                            <b-form-radio value="expense">EXPENSE</b-form-radio>
                        </b-form-radio-group>
                    </b-form-group>
                </div>
                <div class="fieldborder mt-n2">
                    <label>Select type of change requested </label>
                    <OmniSelect placeholder="Select type of change requested" name="Media" :showLabel="false" label="Select Media"
                        :options="ChangeTypeOptions" v-model="ProdEXPAmend.ChangeType" />
                </div>
            </div>
        </div>
        <div class="form-group pt-60 text-right  footer-buttons" style="padding-right:96px !important;">
            <button class="btn btn-link text-uppercase" @click="Cancel()">
                CANCEL
            </button>
            <button v-if="IsDraftVisible" :disabled="!IsFormFilled" class="text-uppercase btn btn-secondary btn-primary" @click="SaveAsDraft()">
                SAVE FOR LATER
            </button>
            <button class="text-uppercase btn custom-button btn-primary" @click="Next()" :disabled="this.$v.$invalid">
                NEXT
            </button>
        </div>

    </div>
</template>

<script>
import { mapGetters } from "vuex";
import service from "../../../services/Dropdowns";
import { required, minLength } from "vuelidate/lib/validators";
import { TheMask } from 'vue-the-mask';
import amendProductionVendorSaveAsDraft from '../../../mixins/amendProductionVendorSaveAsDraft';
export default {
    mixins: [amendProductionVendorSaveAsDraft],
    data() {
        return {
            EditLoad: {
                EntityLoaded: false,
                AgencyLoaded: false,
            },
            EntityList:[],
            AgencyList: [],
            ChangeTypeOptions: [{
                    label: "Address",
                    value: "Address"
                },{
                    label: "Banking",
                    value: "Banking"
                },{
                    label: "Both",
                    value: "Both"
             },],
        }
    },
    props: {
        id: {
            type: Number,
            required: false,
        },
        isDraft: {
            type: Boolean,
            required: false
        },
    },
    components: {
        TheMask
    },
    validations: {
        ProdEXPAmend: {
            EmployeePhoneNumber: {
                minLength: minLength(10)
            },
            Entity: {
                required
            },
            EmployeeAgency: {
                required: required,
            },
            RequestType: {
                required: required,
            },
            ChangeType: {
                required: required,
            },
        }
    },
    computed: {
        IsDraftVisible: function () {
            return this.id == null || this.id == 0 || this.isDraft == true;
        },
        IsFormFilled() {
            return this.ProdEXPAmend.EmployeePhoneNumber !== null || this.ProdEXPAmend.Entity !== null || this.ProdEXPAmend.RequestType !== null || this.ProdEXPAmend.ChangeType !== null;
        },
        IsAgencyLoaded() {
            return this.EditLoad && this.EditLoad.AgencyLoaded;
        },
        IsEntityLoaded() {
            return this.EditLoad && this.EditLoad.EntityLoaded;
        },
        IsEdit() {
            return this.id && !isNaN(this.id) && parseInt(this.id) > 0 ? true : false;
        },
        hasMinimumOne() {
            return this.ProdEXPAmend.EmployeePhoneNumber.includes('1');
        },
        ...mapGetters('prodexpamend', {
            ProdEXPAmend: 'ProdEXPAmend',
        }),
        FormatPhoneNumber() {
            const infoFromPhone = this.ProdEXPAmend.EmployeePhoneNumber || '';
            return infoFromPhone.length > 10 ? '####################' : '1-###-###-#####';
        },
    },
    mounted() {
        this.LoadDropdownValues();
    },
    activated() {
        this.$parent.$emit("stepInitiated", this.$route.meta.tabIndex);
    },
    watch: {
        "ProdEXPAmend.EmployeeAgency": function (val) {          
            let Agency = this.AgencyList.findIndex((item) => {
                return item.value == val;
            });
            if (Agency > -1) {
                this.ProdEXPAmend.AgencyName = this.AgencyList[Agency].label;
            } else {
                this.ProdEXPAmend.AgencyName = "";
            }
        },
        "ProdEXPAmend.Entity": function (val) {
            let entity = this.EntityList.findIndex((item) => {
                return item.value == val;
            });
            if (entity > -1) {
                this.ProdEXPAmend.EntityName = this.EntityList[entity].label;
            } else {
                this.ProdEXPAmend.EntityName = "";
            }
            this.EntityChange();
        },
        "ProdEXPAmend.ChangeType": function (val) {
            if (val == "Banking") {
                this.ProdEXPAmend.RemittanceCountry = '';
                this.ProdEXPAmend.StreetAddressLine1 = '';
                this.ProdEXPAmend.RemittanceCity = '';
                this.ProdEXPAmend.RemittanceState = '';
                this.ProdEXPAmend.RemittanceZipCode = '';
            }
        },
        "ProdEXPAmend.EmployeePhoneNumber": function() {
            if (this.ProdEXPAmend.EmployeePhoneNumber.length > 10) {
                this.FormatPhoneNumber = true;
            }
            else {
                this.FormatPhoneNumber = false;
            }
        },
    },
    methods: {
        AssignAgencyName() {
            let agency = this.AgencyList.findIndex((item) => {
                return item.value == this.ProdEXPAmend.EmployeeAgency;
            });
            if (agency > -1) {
                this.ProdEXPAmend.AgencyName = this.AgencyList[agency].label;
            } else {
                this.ProdEXPAmend.AgencyName = "";
            }
        },
        async LoadAgencySelectedValue() {
            if (this.IsEdit) {
                this.$set(this.EditLoad, "AgencyLoaded", true);
                await this.AssignAgencyName();
            }
        },
        LoadEntitySelectedValue() {
            if (this.IsEdit) {
                this.$set(this.ProdEXPAmend, "Entity", this.ProdEXPAmend.Entity);
                const entity = this.EntityList.find(item => item.value == this.ProdEXPAmend.Entity);
                this.ProdEXPAmend.EntityName = entity ? entity.label : "";
                this.$set(this.EditLoad, "EntityLoaded", true);
            }
        },
        EntityChange() {
            var entityid = this.ProdEXPAmend.Entity;
            service
                .getAgencyDropdownValues(entityid, entityid)
                .then((res) => {
                this.AgencyList = res.data;
                if (this.IsEdit && !this.IsAgencyLoaded) {
                    this.LoadAgencySelectedValue();
                } else {
                    if (res.data.length == 1) {
                        this.ProdEXPAmend.EmployeeAgency = res.data[0].value;
                    } else {
                        this.ProdEXPAmend.EmployeeAgency = null;
                    }
                }
                })
                .catch((err) => {
                    alert(err);
                });
            },
        async LoadDropdownValues() {
            service
            .getOriginalEntityRecords("Financial Entity")
            .then((res) => {
                this.EntityList = res.data;
                if (this.IsEdit && !this.IsEntityLoaded) {
                    this.LoadEntitySelectedValue();
                }
            })
            .catch((err) => {
                alert(err);
            });
        },
        SetDirty(propertyName) {
            this.$v.ProdEXPAmend[propertyName].$touch();
        },
        ResetDirty(propertyName) {
            this.$v.ProdEXPAmend[propertyName].$reset();
        },
        Next() {
            this.$parent.$emit("stepChanged", this.$route.meta.tabIndex);
            if (this.id) {
                this.$router.push({
                    name: "Production Expense Amend External Attachment",
                    params: {
                        id: this.id,
                        isDraft: this.isDraft
                    }
                });
            }
            else {
                this.$router.push({
                    name: "Production Expense Amend External Attachment"
                });
            }
        },
        Cancel() {
            this.$router.push("/VendorRequests");
        }

    }
}
</script>

<style scoped>
.footer-buttons {
    z-index: 9;
}

.agree-checkbox .custom-control-label {
    font-weight: 400;
    font-size: 12px;
}
</style>
